import { useEffect, useState } from "react";
import { CropImage } from "../../components/utils/ImageTreatment";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/formatted/UseWindowsDimensions";
import { Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getHistoryFillingSpeed } from "../../services/container";
import {
  formatMonitoringTakenLine,
  getMonitoringPredictionDisplay,
  getMonitoringPredictionLabel,
  MONITORING_IMAGE_SIZE,
} from "./monitoringRowUtils";

const AppCollectRow = ({
  container,
  containersSelected,
  setContainersSelected,
  setConfirmationCollectModal,
  modalContainer,
  setModalContainer,
  setAlertType,
}) => {
  const { t } = useTranslation();
  const { widthWindow } = useWindowDimensions();
  const [showModal, setShowModal] = useState(false);
  const [fillingSpeed, setFillingSpeed] = useState(null);

  useEffect(() => {
    getHistoryFillingSpeed(container._id).then((response) => {
      if (response.status === 200) {
        setFillingSpeed(response.data);
      }
    });
  }, [container._id]);

  const takenLine = formatMonitoringTakenLine({
    time: container._time,
    t,
  });

  const prediction = getMonitoringPredictionDisplay({
    container,
    fillingSpeed,
    t,
  });

  const predictionLabel = getMonitoringPredictionLabel(container, t);

  const scheduleEnabled = container.alertForFilling || container.packmatActive;

  return (
    <>
      <article className="monitoring-row-card">
        <div className="monitoring-row-layout">
          <div className="monitoring-row-image-wrap">
            <button
              type="button"
              className="monitoring-row-image-hit"
              onClick={() => setModalContainer(container)}
              aria-label={container.wasteName}
            />
            <CropImage
              container={container}
              data={container}
              containersSelected={containersSelected}
              setContainersSelected={setContainersSelected}
              imgDivWidth={MONITORING_IMAGE_SIZE}
              imgDivHeight={MONITORING_IMAGE_SIZE}
              isTooltip={false}
              isMap={false}
              isCharacterization={false}
              displayLegend={false}
              materialsDropdownToDisplay={[]}
              showCheckbox={false}
              onClickZoomButton={() => setModalContainer(container)}
              displayToBlock={false}
              setContainerActive={null}
            />
          </div>

          <div className="monitoring-row-body">
            <div className="monitoring-row-header">
              <span
                className="monitoring-row-waste-name"
                title={container.wasteName}
              >
                {container.wasteName}
              </span>
              {container.alertForFilling && container.collectorEmail && (
                <span className="monitoring-row-auto">
                  <i className="fas fa-sync-alt" aria-hidden />
                  Auto
                </span>
              )}
            </div>

            <p className="monitoring-row-reading">{takenLine}</p>

            {container.positioning && (
              <span className="monitoring-row-pill">
                {container.positioning}
              </span>
            )}

            <div className="monitoring-row-metrics">
              {container.activatedFillingLevelOption && (
                <div className="monitoring-row-metric-row">
                  <span>{t("Filling level")}</span>
                  <span>{container.filling_level}%</span>
                </div>
              )}

              <div
                className={
                  prediction.muted
                    ? "monitoring-row-metric-row monitoring-row-metric-row-muted"
                    : "monitoring-row-metric-row"
                }
              >
                <span>{predictionLabel}</span>
                <span
                  className={
                    prediction.danger
                      ? "monitoring-row-metric-value-danger"
                      : undefined
                  }
                >
                  {prediction.value}
                </span>
              </div>
            </div>

            {container.activatedFillingLevelOption && (
              <div className="monitoring-row-actions">
                <button
                  type="button"
                  className={
                    scheduleEnabled
                      ? "monitoring-row-schedule-button"
                      : "monitoring-row-schedule-button monitoring-row-schedule-button-disabled"
                  }
                  disabled={!scheduleEnabled}
                  onClick={() => setShowModal(true)}
                >
                  {t("Schedule")}
                </button>
              </div>
            )}
          </div>
        </div>
      </article>

      {modalContainer?._id === container._id && (
        <Modal
          isOpen={!!modalContainer}
          toggle={() => setModalContainer(null)}
          className="monitoring-modal monitoring-modal-image"
        >
          <section className="monitoring-modal-header monitoring-modal-header-compact">
            <span />
            <FontAwesomeIcon
              icon="times"
              className="monitoring-modal-close"
              onClick={() => setModalContainer(null)}
            />
          </section>
          <section className="monitoring-modal-image-stage">
            <CropImage
              container={container}
              data={container}
              containersSelected={containersSelected}
              setContainersSelected={setContainersSelected}
              imgDivWidth={widthWindow * 0.9}
              imgDivHeight={380}
              isTooltip={false}
              isMap={false}
              isCharacterization={false}
              displayLegend={false}
              materialsDropdownToDisplay={[]}
              showCheckbox={false}
              onClickZoomButton={() => null}
              displayToBlock={false}
              setContainerActive={null}
            />
          </section>
        </Modal>
      )}

      {showModal && (
        <Modal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          className="monitoring-modal monitoring-modal-schedule"
        >
          <section className="monitoring-modal-header monitoring-modal-header-compact">
            <span />
            <FontAwesomeIcon
              icon="times"
              className="monitoring-modal-close"
              onClick={() => setShowModal(!showModal)}
            />
          </section>
          <div className="monitoring-modal-schedule-actions">
            {container.alertForFilling &&
              container.status !== "remove_driver_exchange" &&
              container.collectorEmail && (
                <button
                  type="button"
                  className="monitoring-modal-button monitoring-modal-button-primary monitoring-modal-button-block"
                  onClick={() => {
                    setAlertType("rotation");
                    setConfirmationCollectModal(true);
                    setShowModal(false);
                  }}
                >
                  {t("schedule_pickup")}
                </button>
              )}
            <button
              type="button"
              className="monitoring-modal-button monitoring-modal-button-primary monitoring-modal-button-block"
              onClick={() => {
                setAlertType("packmat");
                setConfirmationCollectModal(true);
                setShowModal(false);
              }}
            >
              {t("request_compaction")}
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AppCollectRow;
